import { ChangeDetectorRef, Component, inject, ChangeDetectionStrategy } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import type { DialogComponentI } from '@core/user-interface-legacy';
import {
  ConfirmDialogVariant,
  CheckboxComponent,
  ConfirmDialogComponent,
} from '@core/user-interface-legacy';

import type { UnassignLocationDialogResult } from './confirm-unassign-location-dialog.types';

@Component({
  selector: 'rt-confirm-unassign-location-dialog',
  template: `
    <rt-confirm-dialog
      [title]="'app.locations.unassign_confirm.title' | translate"
      [agreeLabel]="'app.locations.unassign_confirm.agree_label' | translate"
      [cancelLabel]="'app.common.cancel' | translate"
      [variant]="ConfirmDialogVariant.Warning"
      [triggerUpdateOnInit]="true"
      [isCancelable]="true"
      [closePayload]="{ payload: { dontShowAgain: this.dontShowAgain } }"
    >
      <div padding-bottom-small>
        {{ 'app.locations.unassign_confirm.message' | translate }}
      </div>
      <rt-checkbox [checked]="dontShowAgain" (valueChange)="setDontShowAgain($event)"
        >{{ 'app.locations.unassign_confirm.not_show_again' | translate }}
      </rt-checkbox>
    </rt-confirm-dialog>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CheckboxComponent, ConfirmDialogComponent, TranslatePipe],
})
export class ConfirmUnassignLocationDialogComponent implements DialogComponentI<
  void,
  UnassignLocationDialogResult | undefined
> {
  private readonly cdRef = inject(ChangeDetectorRef);

  public ConfirmDialogVariant: typeof ConfirmDialogVariant = ConfirmDialogVariant;
  public dontShowAgain: boolean = false;

  public setDontShowAgain($event: string | boolean) {
    this.dontShowAgain = !!$event;
    this.cdRef.detectChanges();
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public setDialogData(data: any, triggerUpdate: boolean): void {}
}
